import React, { useState, useRef, useLayoutEffect } from 'react';
import styled from 'styled-components';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import InlineLabel from 'shared/components/birch/inline_label';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { HelpTooltip } from '@grnhse/seedling/lib/birch/components/tooltips';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix(
  'talent_matching.panel.rediscovery_application_history'
);

const LabelRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const Clamp = styled.div<{ expanded: boolean }>`
  ${({ expanded }) =>
    !expanded &&
    `
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  `}
`;

type Props = {
  summary: string;
};

const ScorecardSummary = ({ summary }: Props) => {
  const [expanded, setExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }
    setIsTruncated(el.scrollHeight > el.clientHeight + 1);
  }, [summary]);

  return (
    <Stack spacing={0.5}>
      <LabelRow>
        <InlineLabel>{t('scorecard_summary_label')}</InlineLabel>
        <HelpTooltip
          label={t('scorecard_summary_label_tooltip')}
          ariaLabel={t('scorecard_summary_label_tooltip')}
        />
      </LabelRow>

      <Clamp ref={ref} expanded={expanded}>
        <SecondaryBody>{summary}</SecondaryBody>
      </Clamp>
      {isTruncated && (
        <Stack alignItems="flex-start" sx={{ marginLeft: '-6px' }}>
          <TertiaryButton onClick={() => setExpanded(!expanded)} size="sm">
            {expanded ? t('view_less') : t('view_more')}
          </TertiaryButton>
        </Stack>
      )}
    </Stack>
  );
};

export default ScorecardSummary;
